/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { URLS } from '../../errorTextsConstants';

const equipmentUrl = 'https://www.movistar.es/equipamiento/';
const routerWifi6Url = 'https://www.movistar.es/equipamiento/router-smart-wifi-6/';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      UNAVAILABLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'El equipamiento solicitado no es compatible con tus productos contratados',
          buttons: [
            {
              link: URLS.PACK_CONFIG,
              label: 'Ver productos miMovistar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque',
        },
      },
      ALREADY_HIRED_EQUIPMENT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya dispones del equipamiento solicitado',
          buttons: [
            {
              link: equipmentUrl,
              label: 'Volver al listado',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto ya contratado',
        },
      },
      UNAVAILABLE_OR_ALREADY_HIRED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tus producto contratados no son compatibles o ya dispones del equipamiento solicitado',
          buttons: [
            {
              link: equipmentUrl,
              label: 'Volver al listado',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'producto incompatible con parque o ya contratado',
        },
      },
      ROUTER_WIFI_6_NEEDED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Tenemos una alternativa mejor para ti',
          msg: ['Para mejorar la cobertura y velocidad en tu domicilio cambia tu router por el Router Smart WiFi 6.','Una vez instalado, si aún necesitas más cobertura, podrás contratar el Amplificador Smart WiFi 6.'],
          buttons: [
            {
              link: routerWifi6Url,
              label: 'Ver Router Smart WiFi 6',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'necesario router wifi6',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
